<app-page-layout>
    <sh-breadcrumbs breadcrumbs>
        <sh-breadcrumb-item [label]="'common.general.home' | translate" href="/"></sh-breadcrumb-item>
        <sh-breadcrumb-item
            [label]="'common.out-of-office.manager.title' | translate"
            href="/settings/out-of-office"
        ></sh-breadcrumb-item>
    </sh-breadcrumbs>

    <h1 title class="text-2xl font-bold font-sh-bree-headline text-shui-text-strong">
        {{ 'common.out-of-office.manager.title' | translate }}
    </h1>

    <div class="grid grid-cols-12 w-full gap-4 flex-1 min-h-0 overflow-hidden">
        <app-out-of-office-calendar
            [dateSpans]="dateSpans()"
            [selectedDateSpan]="
                selectedEntry() ? { startDate: selectedEntry()!.startDate, endDate: selectedEntry()!.endDate } : null
            "
            class="col-span-9 h-full min-h-0"
        ></app-out-of-office-calendar>
        <div class="col-span-3 bg-shui-base-3 rounded-md h-full min-h-0 overflow-auto p-6 mt-[69px]">
            <sh-text size="header-2">{{
                'common.out-of-office.manager.your-planned-out-of-office-days' | translate
            }}</sh-text>
            <div class="h-px w-full bg-shui-base-1 my-4 mt-2"></div>
            <div class="flex flex-col gap-2 mt-2">
                @if (isLoading()) {
                    <div class="bg-shui-base-2 h-10 rounded-md animate-pulse"></div>
                    <div class="bg-shui-base-2 h-10 rounded-md animate-pulse opacity-90"></div>
                    <div class="bg-shui-base-2 h-10 rounded-md animate-pulse opacity-80"></div>
                }

                @for (entry of entries(); track entry.id) {
                    @if (selectedEntryId() === entry.id && editorMode() === 'edit') {
                        <app-out-of-office-entry-editor
                            mode="edit"
                            [dateRange]="[entry.startDate, entry.endDate]"
                            [user]="entry.coverageGid"
                            [isSaving]="isSaving()"
                            (updateClicked)="onUpdateEntry($event)"
                            (deleteClicked)="onDeleteEntry()"
                            (cancelClicked)="selectedEntryId.set(null)"
                        ></app-out-of-office-entry-editor>
                    } @else {
                        <button
                            type="button"
                            data-testid="settings-ooo-entry"
                            class="bg-shui-base-2 p-2 rounded-md w-full text-left border-none transition-colors cursor-pointer"
                            (click)="onSelectEntry(entry.id)"
                        >
                            <sh-text size="title-1" color="primary">{{ entry.dateRange }}</sh-text>
                            <sh-text size="body-1" color="secondary">{{ entry.user }}</sh-text>
                        </button>
                    }
                } @empty {
                    @if (!isLoading()) {
                        <sh-text size="body-1" color="secondary" class="text-center my-8">{{
                            'common.out-of-office.manager.no-planned-out-of-office-days' | translate
                        }}</sh-text>
                    }
                }

                @if (isEditorVisible() && editorMode() === 'create') {
                    <app-out-of-office-entry-editor
                        mode="create"
                        [dateRange]="[]"
                        user=""
                        [isSaving]="isSaving()"
                        (updateClicked)="onUpdateEntry($event)"
                        (deleteClicked)="onDeleteEntry()"
                        (cancelClicked)="isEditorVisible.set(false)"
                    ></app-out-of-office-entry-editor>
                }
            </div>
            <div class="flex items-center justify-end mt-4">
                <sh-button
                    data-testid="settings-ooo-button-plan-new"
                    [label]="'common.out-of-office.manager.plan-new-out-of-office-days' | translate"
                    size="max-content"
                    icon="plus"
                    icon-position="start"
                    [disabled]="isLoading()"
                    (click)="onCreateEntry()"
                ></sh-button>
            </div>
        </div>
    </div>
</app-page-layout>
